export enum AmplifyRouteTypeEnum {
    default,
    editorial,
    editorialHype,
    wire,
    wireHype,
    wireReport
}
